"use client";

import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";

import { ProductTile } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/ProductTile";
import { ProductTileType } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/ProductTileType";

import { ISDUIProductTileVariantRendererProps } from "../types";

export const SDUIProductTileEvaluateRenderer = ({
  product,
  brand,
}: ISDUIProductTileVariantRendererProps) => {
  useTraceComponentRender("ProductTileItem");

  return (
    <ProductTile
      productTile={product}
      productTileType={ProductTileType.SDUI_EVALUATE}
      brand={ILeanProductTile.IBrand.build(brand)}
    />
  );
};
